module.exports = __webpack_public_path__ + "static/media/stfrancisassisi.cbbead95.webp";